/**
 * This path represents the cloudflare configuration stored in https://gitlab.com/vistaprint-org/merchandising-technology/edge-services/cloudflare-edge-configuration/
 * This is the base path that cloudflare will serve our app from on the main vista.com domain.
 * This value must match the one in the vite.config.mts file as that will be used as a prefix for the static assets in the compiled code.
 */
export const COLLABORATE_BASE_PATH = '/design/collaboration';
